import { VenuePage } from "./VenuePage";
import {
  useActivitiesQuery,
  useDaysliceConfigQuery,
  useGreeterEventsQuery,
  useBundlesQuery,
  useThemesQuery,
  useVenueQuery,
  useVenuesQuery,
} from "@greeter/guest-api-hooks";
import { mapQuery } from "@greeter/util";
import { useGreeterGuestApi } from "@greeter/matter";
import { useIonViewWillLeave } from "@ionic/react";
import { usePersistentStore } from "@greeter/store";
import { useDetectTab } from "@greeter-guest/hooks";
import { useRouteMatch } from "react-router-dom";
import { Tab, VenueRouteV2 } from "@greeter-guest/utility/Routes";

export type VenuePageApiHandlerProps = {
  venueId?: string;
};

export function VenuePageApiHandler({ venueId }: VenuePageApiHandlerProps) {
  const { api } = useGreeterGuestApi();

  const tab = useDetectTab();
  const routeMatch = useRouteMatch<{ venueId: string }>(
    VenueRouteV2.get(tab ?? Tab.Venues).template()
  );
  venueId = venueId ?? routeMatch?.params.venueId ?? "NONE";

  const venueQuery = useVenueQuery(venueId);
  const greeterEventsQuery = useGreeterEventsQuery(venueId);
  const activitiesQuery = useActivitiesQuery(venueId);
  const themesQuery = useThemesQuery(venueId);
  const bundlesQuery = useBundlesQuery(venueId);
  const venuesQuery = useVenuesQuery(
    (greeterEventsQuery.data ?? []).map((ge) => ge.venueId)
  );
  const daysliceConfigQuery = useDaysliceConfigQuery();

  const store = usePersistentStore<string>();

  useIonViewWillLeave(() => {
    if (!venueQuery.data) return;

    const venue = venueQuery.data;

    store.save("greeter.city", venue.address.city);
    store.save("greeter.country", venue.address.country);
  }, [venueQuery.data]);

  return (
    <VenuePage
      venue={mapQuery(venueQuery)}
      products={bundlesQuery.data}
      greeterEvents={greeterEventsQuery.data ?? []}
      activities={activitiesQuery.data ?? []}
      themes={themesQuery.data}
      venues={venuesQuery.data}
      daysliceConfig={daysliceConfigQuery.data!}
    />
  );
}
